import { render, staticRenderFns } from "./DetailedReportPeriod.vue?vue&type=template&id=8af245b0&scoped=true&"
import script from "./DetailedReportPeriod.vue?vue&type=script&lang=js&"
export * from "./DetailedReportPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af245b0",
  null
  
)

export default component.exports